import React from 'react';
import PropTypes from 'prop-types';

import TierSelector from './TierSelector';
import DateSelector from './DateSelector';
import Import from './Import';

import FormSection from 'ui/FormSection';
import Button from 'ui/Button';

import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';

const Content = ({open, subscription, onSubscriptionChange, tiers, updatingSubscription, onDeleteRequest }) => {

  const handleChange = ({target: {name, value}}) => {
    let newSubscription = { ...subscription, [name]: value };
    onSubscriptionChange(newSubscription);
  };

  const showDeleteButton = open === 'single' && subscription.id && !subscription.paid;

  return (
    <>
      <FormSection slim>
        {open === 'single' && 
          <TextField
            fullWidth
            color='warning'
            name={'email'}
            size={'small'}
            label={'User Email'}
            value={ subscription.email}
            onChange={handleChange}
            disabled={ updatingSubscription }
          />
        }

        {open === 'import' &&
          <Import
            subscription={subscription}
            onSubscriptionChange={onSubscriptionChange}
          />
        }

        <TierSelector
          tiers={tiers} 
          subscription={subscription} 
          onSubscriptionChange={onSubscriptionChange}
        />

        <DateSelector
          tiers={tiers} 
          subscription={subscription} 
          onSubscriptionChange={onSubscriptionChange}
        />

        {showDeleteButton &&
          <Button
            onClick={onDeleteRequest}
            text
            size={'small'}
            icon={DeleteIcon}
            iconColor={'error'}
            className={'student-delete-button'}
          >
            Delete User
          </Button>
        }
      </FormSection>
    </>
  );
};

Content.propTypes = {
  open: PropTypes.string,
  subscription: PropTypes.object,
  onSubscriptionChange: PropTypes.func,
  tiers: PropTypes.array,
  updatingSubscription: PropTypes.object,
  onDeleteRequest: PropTypes.func,
};

export default Content;